import { getCurrentSupportedApiVersions, validateDomainAndGetStoreUrl, validateApiVersion, createGraphQLClient, generateGetHeaders, generateGetGQLClientParams } from '@shopify/graphql-client';
import { CLIENT, DEFAULT_CONTENT_TYPE, SDK_VARIANT_HEADER, DEFAULT_SDK_VARIANT, SDK_VERSION_HEADER, DEFAULT_CLIENT_VERSION, SDK_VARIANT_SOURCE_HEADER, PUBLIC_ACCESS_TOKEN_HEADER, PRIVATE_ACCESS_TOKEN_HEADER } from './constants.mjs';
import { validateRequiredAccessTokens, validatePrivateAccessTokenUsage } from './validations.mjs';
function createStorefrontApiClient(_ref) {
  let {
    storeDomain,
    apiVersion,
    publicAccessToken,
    privateAccessToken,
    clientName,
    retries = 0,
    customFetchApi,
    logger
  } = _ref;
  const currentSupportedApiVersions = getCurrentSupportedApiVersions();
  const storeUrl = validateDomainAndGetStoreUrl({
    client: CLIENT,
    storeDomain
  });
  const baseApiVersionValidationParams = {
    client: CLIENT,
    currentSupportedApiVersions,
    logger
  };
  validateApiVersion({
    ...baseApiVersionValidationParams,
    apiVersion
  });
  validateRequiredAccessTokens(publicAccessToken, privateAccessToken);
  validatePrivateAccessTokenUsage(privateAccessToken);
  const apiUrlFormatter = generateApiUrlFormatter(storeUrl, apiVersion, baseApiVersionValidationParams);
  const config = {
    storeDomain: storeUrl,
    apiVersion,
    ...(publicAccessToken ? {
      publicAccessToken
    } : {
      privateAccessToken: privateAccessToken
    }),
    headers: {
      'Content-Type': DEFAULT_CONTENT_TYPE,
      Accept: DEFAULT_CONTENT_TYPE,
      [SDK_VARIANT_HEADER]: DEFAULT_SDK_VARIANT,
      [SDK_VERSION_HEADER]: DEFAULT_CLIENT_VERSION,
      ...(clientName ? {
        [SDK_VARIANT_SOURCE_HEADER]: clientName
      } : {}),
      ...(publicAccessToken ? {
        [PUBLIC_ACCESS_TOKEN_HEADER]: publicAccessToken
      } : {
        [PRIVATE_ACCESS_TOKEN_HEADER]: privateAccessToken
      })
    },
    apiUrl: apiUrlFormatter(),
    clientName
  };
  const graphqlClient = createGraphQLClient({
    headers: config.headers,
    url: config.apiUrl,
    retries,
    customFetchApi,
    logger
  });
  const getHeaders = generateGetHeaders(config);
  const getApiUrl = generateGetApiUrl(config, apiUrlFormatter);
  const getGQLClientParams = generateGetGQLClientParams({
    getHeaders,
    getApiUrl
  });
  const client = {
    config,
    getHeaders,
    getApiUrl,
    fetch: function () {
      return graphqlClient.fetch(...getGQLClientParams(...arguments));
    },
    request: function () {
      return graphqlClient.request(...getGQLClientParams(...arguments));
    },
    requestStream: function () {
      return graphqlClient.requestStream(...getGQLClientParams(...arguments));
    }
  };
  return Object.freeze(client);
}
function generateApiUrlFormatter(storeUrl, defaultApiVersion, baseApiVersionValidationParams) {
  return apiVersion => {
    if (apiVersion) {
      validateApiVersion({
        ...baseApiVersionValidationParams,
        apiVersion
      });
    }
    const urlApiVersion = (apiVersion !== null && apiVersion !== void 0 ? apiVersion : defaultApiVersion).trim();
    return "".concat(storeUrl, "/api/").concat(urlApiVersion, "/graphql.json");
  };
}
function generateGetApiUrl(config, apiUrlFormatter) {
  return propApiVersion => {
    return propApiVersion ? apiUrlFormatter(propApiVersion) : config.apiUrl;
  };
}
export { createStorefrontApiClient };